import { cloneDeep, get, sortBy } from 'lodash';
import { TimeFormatType } from '../../../../../common/components/TimeFormat/TimeFormat';
import { PG_EXTERNAL_TYPES, PG_NODES_TYPES } from '../../../../../common/constants/plaza/graphs/graphConstants';
import { plazaGraphsActionTypes } from '../../../../../common/constants/plaza/graphs/store/constants';

import { prefix } from './constants';

const types = plazaGraphsActionTypes(prefix);

const defaultState = {
  plaza: {},
  topology: [],
  nodes: null,
  isFetching: {},
  timeSeries: null,
  timeZone: {
    format: TimeFormatType.UTC,
    offset: 0,
  },
};

function plazaGraphsReducer(state = defaultState, action) {
  switch (action.type) {
    case types.SET_PLAZA:
      return { ...state, plaza: action.payload };

    case types.SET_TOPOLOGY_NODES:
      return { ...state, topology: action.data };

    case types.SET_NODES:
      return { ...state, nodes: { ...state.nodes, [action.payload.nodeType]: action.payload.data } };

    case types.CLEAR_TIME_SERIES:
      return { ...state, timeSeries: null };

    case types.SET_IS_FETCHING:
      return { ...state, isFetching: { ...state.isFetching, [action.nodeType]: action.value } };

    case types.SET_CONSTRAINTS_DATA: {
      const constraintTimeSeries = cloneDeep(get(state, `timeSeries.${PG_NODES_TYPES.CONSTRAINT}`, {}));

      for (const constraintId in action.payload) {
        const nextData = get(action.payload, constraintId, []);

        constraintTimeSeries[constraintId] = sortBy(nextData, 'ts');
      }

      return {
        ...state,
        timeSeries: {
          ...state.timeSeries,
          [PG_NODES_TYPES.CONSTRAINT]: constraintTimeSeries,
        },
      };
    }

    case types.SET_CHARGERS_DATA: {
      const chargersTimeSeries = cloneDeep(get(state, `timeSeries.${PG_NODES_TYPES.CHARGER}`, {}));

      for (const chargerId in action.payload) {
        const nextData = get(action.payload, chargerId, []);

        chargersTimeSeries[chargerId] = sortBy(nextData, 'ts');
      }

      return {
        ...state,
        timeSeries: {
          ...state.timeSeries,
          [PG_NODES_TYPES.CHARGER]: chargersTimeSeries,
        },
      };
    }

    case types.SET_METER_DATA: {
      const meterTimeSeries = cloneDeep(get(state, `timeSeries.${PG_NODES_TYPES.MEASURE}`, {}));

      for (const externalId in action.payload) {
        const nextData = get(action.payload, externalId, {});

        for (const metricCode in nextData) {
          if (!meterTimeSeries[externalId]) {
            meterTimeSeries[externalId] = {};
          }
          meterTimeSeries[externalId][metricCode] = sortBy(nextData[metricCode], 'ts');
        }
      }

      return {
        ...state,
        timeSeries: {
          ...state.timeSeries,
          [PG_NODES_TYPES.MEASURE]: meterTimeSeries,
        },
      };
    }

    case types.SET_TOTALS_DATA: {
      const totalTimeSeries = cloneDeep(get(state, `timeSeries.${PG_EXTERNAL_TYPES.TOTAL}`, {}));

      for (const phase in action.payload) {
        const nextData = get(action.payload, phase, []);

        totalTimeSeries[phase] = sortBy(nextData, 'ts');
      }

      return {
        ...state,
        timeSeries: {
          ...state.timeSeries,
          [PG_EXTERNAL_TYPES.TOTAL]: totalTimeSeries,
        },
      };
    }

    case types.SET_TIME_ZONE:
      return { ...state, timeZone: action.timeZone };

    case types.RESET:
      return defaultState;

    default:
      return state;
  }
}

export default plazaGraphsReducer;
